import { render, staticRenderFns } from "./preOrderBar.vue?vue&type=template&id=022456bc&scoped=true&"
import script from "./preOrderBar.vue?vue&type=script&lang=js&"
export * from "./preOrderBar.vue?vue&type=script&lang=js&"
import style0 from "./preOrderBar.vue?vue&type=style&index=0&id=022456bc&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "022456bc",
  null
  
)

component.options.__file = "preOrderBar.vue"
export default component.exports